import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
export const Hero = () => {
  return <section id="home" className="relative min-h-screen w-full flex flex-col justify-center items-center text-center px-6" data-id="element-143">
      <h1 className="text-4xl md:text-6xl font-bold text-white mb-4" data-id="element-144">
        <span className="block" data-id="element-145">Hello, I'm</span>
        <span className="text-purple-400" data-id="element-146">Maila Akbar</span>
      </h1>
      <p className="text-xl md:text-2xl text-gray-200 max-w-2xl mb-8" data-id="element-147">
        UI/UX Designer creating stunning digital experiences
      </p>
      <div className="flex flex-col md:flex-row gap-4" data-id="element-148">
        <button className="px-8 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-full transition-all transform hover:scale-105" data-id="element-149">
          View My Work
        </button>
        <button className="px-8 py-3 border border-white text-white hover:bg-white hover:text-purple-900 rounded-full transition-all transform hover:scale-105" data-id="element-150">
          Contact Me
        </button>
      </div>
      <a href="#about" className="absolute bottom-10 animate-bounce" data-id="element-151">
        <ArrowDownIcon className="text-white" size={32} data-id="element-152" />
      </a>
    </section>;
};